import { render, staticRenderFns } from "./commandesList.vue?vue&type=template&id=4fef2252&"
import script from "./commandesList.vue?vue&type=script&lang=js&"
export * from "./commandesList.vue?vue&type=script&lang=js&"
import style0 from "./commandesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports